import React, { useEffect, useState } from "react";
import "./clientStyle.css";
import { useNavigate } from "react-router-dom";
import CustomTable from "../../../../components/custom_table/CustomTable";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { BiEditAlt } from "react-icons/bi";
import { PiEye } from "react-icons/pi";
import {
  delete_client,
  get_client_lists,
  get_client_lists_with_pagination,
} from "../../../../api/clientApis";
import { ErrorToast, SuccessToast } from "../../../../toast/toasts";
import CustomBottomPagination from "../../../../components/custom_bottom_pagination/CustomBottomPagination";
import ClientFilter from "./client_filter/ClientFilter";
import { LocalStorageServices } from "../../../../services/localStorageServices";
import CustomDeleteConfirmModal from "../../../../components/custom_delete_confirm_modal/CustomDeleteConfirmModal";

function Clients() {
  const baseRouteUrl = `/ecrs_portal/${LocalStorageServices.getUserRole()}/master_settings`;
  const navigate = useNavigate();
  const [clientListing, setClientListing] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItemPerPage, setTotalItemPerPage] = useState(10);
  const [searchFilter, setSearchFilter] = useState(null);
  const [selectedId, setSelectedId] = useState("");
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [filterStateUpdateHelper, setFilterStateUpdateHelper] = useState(false);

  useEffect(() => {
    get_clients(pageNumber, searchFilter);
  }, [pageNumber, totalItemPerPage, filterStateUpdateHelper]);

  const [isLoading, setIsLoading] = useState(true);

  const get_clients = (pageNumber, filterValue) => {
    const formData = new FormData();
    formData.append("page", pageNumber);
    formData.append("pageItem_count", totalItemPerPage);

    if (filterValue) {
      for (const key in filterValue) {
        formData.append(key, filterValue[key]);
      }
    }

    get_client_lists_with_pagination(formData)
      .then((response) => {
        setClientListing(response.data.data);
        setIsLoading(false);
        setTotalPages(response.data.last_page);
      })
      .catch((error) => {
        let message = "";
        for (const key in error?.data?.errors) {
          if (error?.data?.errors.hasOwnProperty(key)) {
            const keyMessages = error?.data?.errors[key].map(
              (message) => message
            );
            message = message.concat(keyMessages);
          }
        }
        ErrorToast(message);
      });

  };

  // Get privileges details from local storage
  const getPrivilegesDetails = () => JSON.parse(localStorage.getItem("privileges_details") || "[]");

  // Check if a specific privilege exists in"Master Settings" -> Clients
  const hasPrivilege = (privilegeName) =>
    getPrivilegesDetails().some(
      (item) =>
        item.module_name === "Master Settings" &&
        item.submodules?.["Clients"]?.privileges?.some((priv) => priv.name === privilegeName)
    );

  const Is_Clients_View = hasPrivilege("View");
  const Is_Clients_Add = hasPrivilege("Add");
  const Is_Clients_Edit = hasPrivilege("Edit");
  const Is_Clients_Delete = hasPrivilege("Delete");

  const Columns = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
    },
    {
      title: "Clients Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone Number",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      wrapper: (row) => (
        <div>
          <p style={{ color: row.status == "Active" ? "#0A9E02" : "#FF0000" }}>
            {row.status}
          </p>
        </div>
      ),
    },
    (Is_Clients_View || Is_Clients_Edit || Is_Clients_Delete) && {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      action: (row) => (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: 10,
          }}
        >
          {Is_Clients_View && (
            <PiEye
              className="user_action_view"
              onClick={() => {
                navigate(baseRouteUrl + `/${row.id}/view_client`);
              }}
            />
          )}
          {Is_Clients_Edit && (
            <BiEditAlt
              className="user_action_edit"
              onClick={() => {
                navigate(baseRouteUrl + `/${row.id}/update_client`);
              }}
            />
          )}
          {Is_Clients_Delete && (
            <MdOutlineDeleteOutline
              className="user_action_delete"
              onClick={() => {
                setSelectedId(row.id);
                setDeleteConfirmation(true);
              }}
            />
          )}
        </div>
      ),
    },
  ];

  const datas = () => {
    const result =
      clientListing &&
      clientListing.map((item, index) => {
        return {
          key: pageNumber * totalItemPerPage - (totalItemPerPage - (index + 1)),
          id: item.CI_id,
          name: item.CI_name,
          email: item.CI_email,
          phone: item.CI_phone,
          status: item.status_name,
        };
      });
    return result;
  };
  const updatePagination = (pageNumber) => {
    setPageNumber(pageNumber);
  };
  const updateItemPageCount = (pageItemCount) => {
    setTotalItemPerPage(pageItemCount);
  };
  const deleteClient = () => {
    if (selectedId) {
      delete_client(selectedId)
        .then((response) => {
          if (response.status == 200) {
            handleDeleteModalClose(false);
            SuccessToast(response.data.message);
            get_clients(pageNumber);
          }
        })
        .catch((error) => {
          console.log(error);
          handleDeleteModalClose(false);
          ErrorToast(error?.data?.message || error?.data?.error);
          console.log(error);
        });
    }
  };
  const searchfilter = (value) => {
    setSearchFilter(value);
    setPageNumber(1);
    setFilterStateUpdateHelper(!filterStateUpdateHelper);
  };
  const handleDeleteModalClose = (is_close) => {
    setDeleteConfirmation(is_close);
    setSelectedId(null);
  };
  return (
    <div className="clients_module_main_container">
      <p className="clients_title">Clients</p>
      <div className="client_module_filter">
        <ClientFilter searchFilter={searchfilter} />
        {Is_Clients_Add && (
          <button
            className="client_add_button"
            onClick={() => {
              navigate(baseRouteUrl + `/create_new_client`);
            }}
          >
            Add New
          </button>
        )}
      </div>
      <div className="client_table_main_container">
        <CustomTable columns={Columns} rows={datas()} loading={isLoading} />
      </div>
      <div>
        <CustomBottomPagination
          total_items_per_page={totalItemPerPage}
          total_page_count={totalPages}
          current_page={pageNumber}
          on_change_value={updatePagination}
          on_page_count_update={updateItemPageCount}
        />
      </div>
      <CustomDeleteConfirmModal
        module_name={"client"}
        open_modal={deleteConfirmation}
        close_modal={handleDeleteModalClose}
        confirm_function={deleteClient}
      />
    </div>
  );
}

export default Clients;
